import React, { Component } from "react";
import { Table, Card, Row, Button, Image, Col } from "react-bootstrap";
import "./Licensee.css";

import AddLicensee from "./AddLicensee";
import EditLicensee from "./EditLicensee";
import DeleteLicensee from "./DeleteLicensee";
import LicenseeView from "./DetailView";

import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");

class Licensee extends Component {
  constructor() {
    super();
    this.state = {
      showAddModel: false,
      showEditModel: false,
      showDelModel: false,
      showLicenseeDetail: false,
      page: 0,
      perPage: 10,
    };
  }

  componentDidMount() {
    this.props.fetchLicenseeList();
    this.props.fetchCntryCrnvy();
    this.props.fetchStates();
  }

  handleAddLicensee = () => {
    this.setState({
      showAddModel: true,
    });
  };

  handleEditLicensee = (item) => {
    console.log(item);
    this.setState({
      showEditModel: true,
      ItemList: item,
    });
  };

  handleDelLicensee = (item) => {
    // console.log(item);
    this.setState({
      showDelModel: true,
      DeleteItem: item,
    });
  };

  handleLicenseeView = (item) => {
    // console.log(item);
    this.setState({
      showLicenseeDetail: true,
      LicenseeDetailView: item,
    });
  };

  closeAddModel = () => {
    this.setState({
      showAddModel: false,
    });
  };

  closeEditModel = () => {
    this.setState({
      showEditModel: false,
    });
  };

  closeDelModel = () => {
    this.setState({
      showDelModel: false,
    });
  };

  closeLicenseeView = () => {
    this.setState({
      showLicenseeDetail: false,
    });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.pageSelected(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  render() {
    let p = this.state.page + 1;
    const count = this.props.LicenseeCount && this.props.LicenseeCount;
    let licenseePageCount = Math.ceil(count / this.state.perPage);
    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={6} sm={6} md={6} lg={6}>
                <h3>Licensee</h3>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="licenseeRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {count !== 0 && count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => this.handleAddLicensee()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
              <AddLicensee
                districtById={this.props.districtById}
                showAddModel={this.state.showAddModel}
                cntrycrncyList={this.props.cntrycrncyList}
                closeAddModel={this.closeAddModel}
                AddLicenseeProfile={this.props.AddLicenseeProfile}
                statesList={this.props.statesList}
                fetchDistrictById={this.props.fetchDistrictById}
                clearDistrictById={this.props.clearDistrictById}
                resetPage={this.resetPage}
              />
            </div>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>ORG NAME</th>
                    <th>EMAIL</th>
                    <th>MOBILE NUMBER</th>
                    <th>COUNTRY</th>
                    {/* <th>TAX ENABLED</th>
                    <th>TAX PERCENTAGE</th> */}
                    <th>CONTACT PERSON</th>
                    {/* <th>CONTACT EMAIL</th> */}
                    <th>STATUS</th>
                    <th>CREATED DATE</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.LicenseeList &&
                    this.props.LicenseeList.map((item, i) => (
                      <tr key={i}>
                        <td>{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.orgName}
                        </td>
                        <td>
                          {item !== null && item.userId && item.userId.email}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&
                            (item.country && item.country.callingCode) +
                              (item.userId && item.userId.mobileNo)}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.country && item.country.name}
                        </td>

                        <td className="cmn_Cap">
                          {item !== null && item.spocName}
                        </td>
                        {/* <td>{item !== null && item.spocEmail}</td> */}

                        <td>
                          {item !== null && item.status === "active"
                            ? "Active"
                            : "Suspended"}
                        </td>
                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              /* onClick={() =>
                                this.handleLicenseeView({
                                  item: item,
                                })
                              } */
                              onClick={() => this.handleLicenseeView(item)}
                            ></i>

                            <i
                              className="fa fa-edit fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleEditLicensee(item)}
                            ></i>

                            <i
                              className="fa fa-trash fa-lg"
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleDelLicensee(item)}
                            ></i>
                            <DeleteLicensee
                              showDelModel={this.state.showDelModel}
                              closeDelModel={this.closeDelModel}
                              DeleteItem={this.state.DeleteItem}
                              DeleteLicensee={this.props.DeleteLicensee}
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              <LicenseeView
                showDetailView={this.state.showLicenseeDetail}
                closeDetailView={this.closeLicenseeView}
                LicenseeDetailView={this.state.LicenseeDetailView}
              />

              {this.state.ItemList && (
                <EditLicensee
                  showEditModel={this.state.showEditModel}
                  closeEditModel={this.closeEditModel}
                  ItemList={this.state.ItemList}
                  EditLicensee={this.props.EditLicensee}
                  cntrycrncyList={this.props.cntrycrncyList}
                  statesList={this.props.statesList}
                  fetchDistrictById={this.props.fetchDistrictById}
                  clearDistrictById={this.props.clearDistrictById}
                  districtById={this.props.districtById}
                  resetPage={this.resetPage}
                />
              )}

              {(this.props.LicenseeList === undefined ||
                (this.props.LicenseeList &&
                  this.props.LicenseeList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Licensee Found</div>
                </div>
              )}
            </div>
          </Card.Body>

          {licenseePageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={licenseePageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default Licensee;
